export default __webpack_public_path__ + "static/media/Loman.355a9073.png";